module.exports = __webpack_public_path__ + "img/ico_menual06_off.33cedb3b.svg";